<template>
  <div class="login-popup">
    <div class="popup-shadow" @click="hideLoginPopup"></div>
    <div class="popup-container">
      <div class="title">{{ titleText }}</div>
      <uid-token-login
        v-if="showLoginType == loginTypeMap.GUEST && !isHideOtpLogin"
        :isJpUidTokenLogin="false"
      ></uid-token-login>
      <account-login
        v-if="showLoginType == loginTypeMap.ACCOUNT_LOGIN"
      ></account-login>
      <third-party-login v-if="!isJpPlatform"></third-party-login>
      <protocol-link></protocol-link>
      <div class="popup-close" @click="hideLoginPopup"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import UidTokenLogin from '@components/officialWebStore/login/UidTokenLogin.vue';
import AccountLogin from '@components/officialWebStore/login/AccountLogin.vue';
import ThirdPartyLogin from '@components/officialWebStore/login/ThirdPartyLogin.vue';
import ProtocolLink from '@components/officialWebStore/login/ProtocolLink.vue';
import login from '@mixins/officialWebStore/login';
const LOGIN_TYPE_MAP = {
  ACCOUNT_LOGIN: 1,
  GUEST: 2
};
export default {
  name: 'LoginPopup',
  mixins: [login],
  data() {
    return {
      loginTypeMap: LOGIN_TYPE_MAP
    };
  },
  computed: {
    ...mapState({
      visibleTokenLoginPopup: state => state.visibleTokenLoginPopup,
      isJpUidLogin: state => state.login.isJpUidLogin,
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig', 'isJpPlatform']),
    inGameGuideImg() {
      return this.gameInfoConfig.uidTokenGuidePopupGameImg;
    },
    // 是否隐藏OTP令牌登入
    isHideOtpLogin() {
      // 2024.6.25 休闲三消全球版286是游客模式但是没有OTP和用户中心，需要特殊处理隐藏
      const isHideOtpLoginGames = [286];
      return isHideOtpLoginGames.includes(+this.gameId);
    },
    titleText() {
      let text = this.letter.login;
      if (+this.showLoginType !== this.loginTypeMap.ACCOUNT_LOGIN && !this.isHideOtpLogin) {
        text = 'OTP TOKEN';
      }
      if (this.isJpPlatform) {
        text = this.isJpUidLogin ? this.letter.storeAccountIdLogin : 'LoginPassログイン';
      }
      return text;
    }
  },
  components: {
    UidTokenLogin,
    ThirdPartyLogin,
    ProtocolLink,
    AccountLogin
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.login-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
}

.title {
  text-align: center;
  height: 87px;
  line-height: 87px;
  font-size: 26px;
  @include g-popup-title();
  margin: 0;
  border-radius: 10px;
}

.popup-close {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}
@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
    ::v-deep .uid-token-content {
      width: 100%;
    }
    ::v-deep .uid-token .input-box {
      height: 70px;
      margin-bottom: 10px;
    }
    ::v-deep .third-login .space .line {
      width: 368px;
    }
  }
  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }
  .popup-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
